import {
  Box,
  Button,
  Container,
  Flex,
  Image,
  Link,
  ListItem,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Select,
  // Skeleton,
  Text,
  UnorderedList,
  useBreakpointValue,
  VisuallyHidden,
} from '@chakra-ui/react';
import { ITaxonomyTerms } from '@kontent-ai/delivery-sdk';
import { LocationPopup } from 'components/modules/LocationPopup';
import { SECTION_ICON_MAPPING } from 'lib/constants';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { normalize } from 'pages/api/sitemap';
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useCookies } from 'react-cookie';
import slugify from 'slugify';
import { withTranslations } from 'store/translations';
import { moduleMaxWidth } from 'themes/overrides';
import { internalPages } from 'utils/getInternalPage';
import { handleLanguageChange } from 'utils/handleLocaleChange';
import { hrefLink } from 'utils/normalization/hrefLink';
import { GetContentPage } from 'utils/sitemap';

import { LinkType } from '../../lib/enums/LinkType';
import {
  ContentPage,
  ContentPageActor,
  NavigationCategory,
  NavigationItem,
  NavigationLanguageItem,
  Search,
} from '../../models';
import { Navigation } from '../../models/content-types/navigation';
import Breadcrumb from '../base/Breadcrumb';
import { IconComp } from '../base/IconComp';
import { Link as BaseLink } from '../base/Link';
import MainSearch from './MainSearch';
//import { MegaMenu } from './MegaMenu';

//const MegaMenu = dynamic(() => import('./MegaMenu').then((mod) => mod.MegaMenu), { ssr: false });

export type NavProps = {
  navProps: Navigation;
  megaMenuProps: {
    subpages: (ContentPage | NavigationCategory | NavigationLanguageItem | ContentPageActor)[];
    highlightedArticle: ContentPage | ContentPageActor | null;
    itemCodename: string | undefined;
  }[];
  languageSelectors: NavigationLanguageItem[];
  mainSearch: Search;
  isCampaign?: boolean;
  variants?: Awaited<ReturnType<typeof GetContentPage.allLocales>>;
  hasFrontpageCarousel?: boolean;
  shouldHideSearch?: boolean;
  RSTLangSwitch?: [];
};

export interface MegaMenuActiveTabProps {
  codename: any;
  isRST: any;
  subpages: any;
  highlightedArticle: any;
  categoryDescription: string;
  categoryTitle: string;
  linkToOverview: string;
  variants?: Awaited<ReturnType<typeof GetContentPage.allLocales>>;
  navSections?: any;
  link?: any;
}
export interface RSTMenuProps {
  isRST: any;
  subpages: any;
  variants?: Awaited<ReturnType<typeof GetContentPage.allLocales>>;
}

export const NavbarLite: FC<NavProps> = ({
  navProps,
  megaMenuProps,
  mainSearch,
  isCampaign,
  languageSelectors,
  variants,
  hasFrontpageCarousel = false,
}) => {
  const router = useRouter();
  // console.log('nav props ',navProps.system.language)
  // console.log('router ',router.locale)
  //const shouldUseDefaultLocale = shouldForceDefaultLocale(router);
  const translations = withTranslations();
  const NavLinks = navProps.elements.navigationTitles.linkedItems;
  const NavIcon = navProps.elements.logo?.value[0].url;
  const NavIconAltText = navProps.elements.alternativeText.value;

  let oldScrollValue = 0;
  const [isShowNav, setIsShowNav] = useState(true);
  const [isShowMainSearch, setIsShowMainSearch] = useState(false);
  const [megaMenuActiveTab, setMegaMenuActiveTab] = useState<MegaMenuActiveTabProps>();
  let skipContentClickListener;
  const [isMegaMenuActive, setIsMegaMenuActive] = useState(false);
  const [megaMenuIndexMobile, setMegaMenuIndexMobile] = useState(0);
  const [cookie, setCookie] = useCookies(['NEXT_LOCALE']);
  const [isOnFrontpage, setIsOnFrontpage] = useState(hasFrontpageCarousel);
  const isRemovePadding = hasFrontpageCarousel;
  const shouldShowLanguageSelector = navProps.elements.showLanguageSelector.value[0]?.codename === 'yes';
  const [_initialLocaleCookie, _setInitialLocaleCookie] = useCookies(['INITIAL_LOCALE']);
  const linkRef = useRef<HTMLAnchorElement>(null);
  const [insightTheme, setInsightTheme] = useState<ITaxonomyTerms[]>();
  const [skipContentElemName, setSkipContentElemName] = useState(
    window.innerWidth > 1024 ? 'skipToMainContent' : 'skipToMainContentMobile',
  );
  const [activeExploreBy, setActiveExploreBy] = useState<string>();
  const updateTheme = async () => {
    const response_data = await fetch('/api/getTaxonomies');
    const response_json = await response_data.json();
    // console.log("response data - ",response_data)
    if (Array.isArray(response_json))
      response_json.map((item) => {
        if (item.system.codename == 'theme_topic') setInsightTheme(item.terms);
      });
    else console.error('Taxonomy fetch error', response_json);
  };

  const chevIcon =
    useBreakpointValue({
      base: 'chevronDown',
      lg: 'chevronDownSmall',
    }) ?? 'chevronDown';

  useEffect(() => {
    updateTheme();
    const onResize = () => {
      setSkipContentElemName(window.innerWidth > 1024 ? 'skipToMainContent' : 'skipToMainContentMobile');
    };
    window.addEventListener('resize', onResize);
  }, []);
  useEffect(() => {
    //console.log(linkRef.current);
  }, [linkRef]);

  useEffect(() => {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', function (this: any, e) {
        e.preventDefault();
        setIsMegaMenuActive(false);
        document.querySelector(this?.getAttribute('href'))?.scrollIntoView({
          behavior: 'smooth',
        });
      });
    });

    // const isInHomepage = cacheData.get('homepage');
    // console.log('Homepage is', isInHomepage);
    const skipToContentLinkElem = document.getElementById(skipContentElemName);
    if (!skipContentClickListener)
      skipContentClickListener = skipToContentLinkElem?.addEventListener('click', (e) => {
        e.preventDefault();
        setIsShowMainSearch(false);
        setIsMegaMenuActive(false);
        if (skipToContentLinkElem instanceof HTMLAnchorElement) {
          const mainContentElem = document.getElementById(skipToContentLinkElem.href.split('#')[1]);
          if (mainContentElem) {
            mainContentElem.setAttribute('tabindex', '-1');
            mainContentElem.addEventListener(
              'blur',
              () => {
                mainContentElem.removeAttribute('tabindex');
              },
              { once: true },
            );
            mainContentElem.focus();
          }
        }
      });
  });

  const checkScroll = useCallback(() => {
    if (window.scrollY > oldScrollValue && window.scrollY >= 100) {
      setIsShowNav(false);
    } else {
      setIsShowNav(true);
    }

    if (document.getElementById('fronpage-hero-carousel') && window.scrollY >= 100) {
      setIsOnFrontpage(false);
    } else if (document.getElementById('fronpage-hero-carousel') && window.scrollY <= 100) {
      setIsOnFrontpage(true);
    }

    oldScrollValue = window.scrollY;
  }, []);

  const hideMenuEsc = useCallback((e: any) => {
    if (e.key === 'Escape') {
      setIsMegaMenuActive(false);
    }
  }, []);

  const hideMenuClick = useCallback((e: any) => {
    let isPartOfNav = false;
    e.composedPath().forEach((p: any) => {
      if (p.id === 'RambollNavBar') {
        isPartOfNav = true;
      }
    });
    if (!isPartOfNav) {
      setIsMegaMenuActive(false);
    }
  }, []);

  useEffect(() => {
    if (isMegaMenuActive) {
      //document.documentElement.classList.add('scroll-disable');
      window.removeEventListener('scroll', checkScroll, true);
      window.addEventListener('keydown', hideMenuEsc, true);
      window.addEventListener('click', hideMenuClick, true);
    } else {
      //document.documentElement.classList.remove('scroll-disable');
      window.addEventListener('scroll', checkScroll, true);
      window.removeEventListener('keydown', hideMenuEsc, true);
      window.removeEventListener('click', hideMenuClick, true);
    }

    return () => {
      window.removeEventListener('keydown', hideMenuEsc);
      window.removeEventListener('click', hideMenuClick);
      window.removeEventListener('scroll', checkScroll);
    };
  }, [isMegaMenuActive]);

  const toggleMainSearch = () => {
    setIsShowMainSearch((state) => !state);
    setIsMegaMenuActive(false);
  };

  const NavBarMobile = () => {
    return (
      <Flex
        w='100vw'
        h={65}
        display={{ base: 'flex', lg: 'none' }}
        as={'nav'}
        background={!isOnFrontpage ? 'white' : undefined}
        position='relative'
        zIndex={9}
        align={'center'}
        justify={'space-between'}
        p='xs'
        id='mobile-main-nav'
      >
        <VisuallyHidden as={'nav'}>{translations.aria('navigationBar')}</VisuallyHidden>
        <Box display='flex' alignItems='center' flexFlow='row' gap={30}>
          <Box
            as={NextLink}
            href={'/'}
            // TODO: Needs to be a fix for translation here
            aria-label={translations.aria('goToHomepage')}
          >
            <Box
              w={{ base: '96px', lg: '147px' }}
              sx={{
                '@media screen and (max-width: 1032px)': {
                  width: '100px',
                },
              }}
              aria-hidden={true}
              filter={isOnFrontpage && !isMegaMenuActive && !isShowMainSearch ? 'brightness(0) invert(1)' : 'unset'}
            >
              <Image src={NavIcon} alt={NavIconAltText} />
            </Box>
          </Box>
          <Button
            id='skipToMainContentMobile'
            role='link'
            aria-label={translations.common('skipToContent')}
            as='a'
            variant='primary'
            size='md'
            mt='m'
            mb='s'
            href='#main-content'
            margin={0}
            whiteSpace='normal'
            lineHeight={1.15}
            textAlign='center'
            zIndex={101}
            position={'absolute'}
            top={-999}
            _focus={{
              position: 'relative',
              top: 0,
            }}
          >
            {translations.common('skipToContent')}
          </Button>
        </Box>
        <Flex gap='40px' flexDirection='row-reverse'>
          {!!NavLinks.length && (
            <Box
              as={'button'}
              display='flex'
              alignContent='center'
              onClick={() => {
                if (!isMegaMenuActive) {
                  setMegaMenuIndexMobile(0);
                } else {
                  setTimeout(() => {
                    setMegaMenuIndexMobile(0);
                    setIsMegaMenuActive(false);
                  }, 750);
                }
                setIsMegaMenuActive(!isMegaMenuActive);
                setIsShowMainSearch(false);
                setMegaMenuActiveTab(undefined);
              }}
            >
              <IconComp
                iconName={isMegaMenuActive ? 'close' : 'hamburger'}
                chakraStyle={{
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  filter: isOnFrontpage && !isMegaMenuActive && !isShowMainSearch ? 'brightness(0) invert(1)' : 'unset',
                }}
              />
              <VisuallyHidden>{translations.aria('openMenu')}</VisuallyHidden>
            </Box>
          )}
          {!isCampaign && (
            <Box
              as={'button'}
              aria-label={translations.aria('search')}
              filter={isOnFrontpage && !isMegaMenuActive && !isShowMainSearch ? 'brightness(0) invert(1)' : 'unset'}
              onClick={toggleMainSearch}
            >
              <IconComp iconName='search' />
            </Box>
          )}
        </Flex>
      </Flex>
    );
  };
  const NavBarDesktop = () => {
    return (
      <Box
        display={{ base: 'none', lg: 'flex' }}
        as={'nav'}
        position='relative'
        h={'70px'}
        m='auto'
        paddingInlineStart='0'
        paddingInlineEnd='0'
        zIndex={9}
        alignItems={'center'}
        justifyContent={'space-between'}
        pl={'s'}
        pr={'s'}
        pointerEvents={router.locale == navProps.system.language ? 'auto' : 'none'}
        w={isCampaign ? '100%' : 'unset'}
      >
        <VisuallyHidden as={'nav'}>{translations.aria('navigationBar')}</VisuallyHidden>
        <Box
          display='flex'
          alignItems='center'
          flexFlow='row'
          gap={30}
          height={'100%'}
          w={isCampaign ? '100%' : 'unset'}
          justifyContent={isCampaign ? { base: 'unset', lg: 'space-between' } : {}}
        >
          <Box
            as={NextLink}
            href={'/'} // TODO: Needs to be a fix for translation here and be main site url
            aria-label={translations.aria('goToHomepage')}
          >
            <Box
              w={{ base: '96px', lg: '147px' }}
              sx={{
                '@media screen and (max-width: 1032px)': {
                  width: '100px',
                },
                "[data-group='navbargroup']:hover &,[data-group='navbargroup']:focus-within &": { filter: 'unset' },
              }}
              aria-hidden={true}
              filter={isOnFrontpage && !isMegaMenuActive && !isShowMainSearch ? 'brightness(0) invert(1)' : 'unset'}
              //_groupHover={{ filter: 'unset' }}
            >
              <Image src={NavIcon} alt={NavIconAltText} />
            </Box>
          </Box>
          <Button
            id='skipToMainContent'
            role='link'
            aria-label={translations.common('skipToContent')}
            as='a'
            variant='primary'
            size='md'
            mt='m'
            mb='s'
            href='#main-content'
            margin={0}
            whiteSpace='normal'
            lineHeight={1.15}
            textAlign='center'
            zIndex={101}
            position={'absolute'}
            top={-999}
            _focus={{
              position: 'relative',
              top: 0,
            }}
          >
            {translations.common('skipToContent')}
          </Button>
          {isCampaign ? <CampaignNavBarItems /> : <NavBarItems />}
        </Box>

        <Flex height={'100%'}>
          <Box height={'100%'}>
            <UnorderedList
              listStyleType={'none'}
              display='flex'
              height={'100%'}
              position='relative'
              flexDirection={{ base: 'column', lg: 'row' }}
              alignItems={{ base: 'start', lg: 'center' }}
              pt={{ base: 'xs', lg: '0' }}
              mb={{ base: '0', lg: 'unset' }}
              borderBottomColor='mountain.10'
              //borderBottomWidth={{ base: '1px', lg: '0px' }}
              marginInlineStart={0}
              sx={{
                '@media screen and (max-width: 1024px)': {
                  pt: '0',
                  m: 'unset',
                },
              }}
            >
              {mapNavLinks(true)}
            </UnorderedList>
          </Box>
          {!isCampaign && (
            <Box
              mx={{ lg: '10px' }}
              display={{ base: 'none', lg: 'flex' }}
              sx={
                isOnFrontpage && !isMegaMenuActive && !isShowMainSearch
                  ? {
                      svg: { path: { fill: 'white' } },
                      "[data-group='navbargroup']:hover &,[data-group='navbargroup']:focus-within &": {
                        svg: { path: { stroke: 'transparent', fill: 'mountain.base' } },
                      },
                    }
                  : {
                      "[data-group='navbargroup']:hover &,[data-group='navbargroup']:focus-within &": {
                        svg: { path: { stroke: 'transparent', fill: 'mountain.base' } },
                      },
                    }
              }
              //_groupHover={{ svg: { path: { stroke: 'transparent', fill: 'mountain.base' } } }}
            >
              <Box
                as={'button'}
                sx={{ svg: { width: '20px' } }}
                aria-label={translations.aria('search')}
                onClick={toggleMainSearch}
              >
                <IconComp iconName='searchSmall' />
              </Box>
            </Box>
          )}
          {process.env.NEXT_PUBLIC_KONTENT_AI_COLLECTION !== 'default' ? (
            <Link
              isExternal
              data-group
              href='https://www.ramboll.com'
              py={{ base: 'xs' }}
              pl={{ lg: 'xs' }}
              _hover={{
                //textDecoration: 'underline',
                color: isOnFrontpage && !isMegaMenuActive && !isShowMainSearch ? 'white' : 'cyan.web',
              }}
              display='flex'
              alignItems='center'
              textStyle={{ base: 'mobile.h3', lg: 'desktop.body.book.s24' }}
            >
              <IconComp
                iconName='home'
                chakraStyle={{
                  display: { base: 'none', lg: 'block' },
                  sx: {
                    "[data-group='navbargroup']:hover &,[data-group='navbargroup']:focus-within &": {
                      path: {
                        stroke: 'cyan.web',
                        fill: 'cyan.web',
                      },
                    },
                  },
                  // _groupHover: {
                  //   path: {
                  //     stroke: 'cyan.web',
                  //   },
                  // },
                }}
              />
              {translations.common('visitRamboll')}
            </Link>
          ) : null}
        </Flex>
      </Box>
    );
  };
  const NavBarItems = () => {
    return (
      <UnorderedList
        listStyleType={'none'}
        display='flex'
        height={{ base: 'unset', lg: '100%' }}
        position='relative'
        flexDirection={{ base: 'column', lg: 'row' }}
        justifyContent={{ lg: 'space-evenly' }}
        margin='0'
        pt={0}
        w={{ base: '100%', lg: 'auto' }}
        id='unorder'
        sx={{
          '@media screen and (max-width: 1023px)': {
            gap: '10px',
            pt: '40px',
            pb: '30px',
          },
        }}
      >
        {mapNavLinks(false)}
      </UnorderedList>
    );
  };

  const flyoutMenu = (link, navSections) => {
    return (
      <>
        <UnorderedList
          className='third'
          display={'flex'}
          flexFlow={'column nowrap'}
          gap={{ base: '20px', lg: '0px' }}
          listStyleType={'none'}
          margin='0'
          p={{ base: '30px 20px 20px 20px', lg: '20px 60px 20px 20px' }}
          h={{ base: 'auto' }}
          overflowY={{ base: 'visible', lg: 'auto' }}
          // alignSelf={'stretch'}
          sx={{
            '::-webkit-scrollbar': {
              width: '4px',
            },
            '::-webkit-scrollbar-track': {
              width: '6px',
            },
            '::-webkit-scrollbar-thumb': {
              background: 'mountain.20',
              borderRadius: '0',
            },

            scrollbarColor: 'var(--chakra-colors-mountain-20) white',
            scrollbarWidth: 'thin',
            scrollbarGutter: 'stable both-edges',
          }}
        >
          {link?.elements?.category?.title !== 'Insights' &&
          link?.elements?.category?.title != 'Artikkelit' &&
          link?.elements?.category?.title != 'Innsikt' &&
          link?.elements?.category?.title != 'Insikter'
            ? link?.elements?.subpages?.linkedItems?.map((subpage: any, index: number) => {
                const slug = router.query.slug || router.query.mainSubpage || router.query.subcategory;
                const url =
                  subpage.system.type === 'content_page'
                    ? hrefLink(subpage, (slug as unknown as string)?.split('/'), true, router.locale, translations)
                    : subpage.system.type === 'navigation_language_item'
                    ? `${(subpage as NavigationLanguageItem).elements.languageCodename.value}`
                    : subpage.system.type === 'content_page_actor'
                    ? internalPages(
                        translations,
                        (subpage as ContentPageActor).elements.internalCtaLink.value[0]?.codename,
                      ) ?? (subpage as ContentPageActor).elements.externalCtaLink.value
                    : '/';
                return (
                  <ListItem
                    key={index}
                    textStyle={{ base: 'desktop.body.book.s24', lg: 'desktop.body.book.s24' }}
                    // -- Gives different colors to the "Explore by" categories when you press them --
                    color={{
                      base: 'unset',
                      lg:
                        subpage.system.type === 'navigation_category' &&
                        activeExploreBy === subpage.elements.title.value
                          ? 'cyan.web'
                          : 'unset',
                    }}
                    pt={{ base: '0px', lg: '10px' }}
                    pb={{ base: '0px', lg: '10px' }}
                    gap={{ base: '20px', lg: '0px' }}
                  >
                    {subpage.system.type === 'navigation_category' ? (
                      // -- If there are "Explore by" elements present --
                      <Flex
                        alignItems='center'
                        justifyContent={'space-between'}
                        gap='s'
                        sx={{
                          _after: {
                            content: '""',
                            borderBottom: '1px solid',
                            borderColor: 'cyan.web',
                            //
                            w: '100%',
                            display: {
                              base: 'none',
                              lg: activeExploreBy === subpage.elements.title.value ? 'block' : 'none',
                            },
                          },
                        }}
                      >
                        <Box
                          as='button'
                          _hover={{ color: 'cyan.web' }}
                          textStyle={{ base: 'desktop.body.book.s24', lg: 'desktop.body.book.s24' }}
                          onClick={() => {
                            const timeout = window.innerWidth >= 1024 ? 200 : 0;
                            setActiveExploreBy((subpage as NavigationCategory).elements.title.value);
                            // -- Set explore by pages & animation --
                            // if (
                            //   (subpage as NavigationCategory).elements.linkedPages.linkedItems &&
                            //   exploreByPages !== (subpage as NavigationCategory).elements.linkedPages.linkedItems
                            // ) {
                            //   setIsChangingViewsExploreBy(true);
                            //   setTimeout(() => {
                            //     setExploreByPages(
                            //       (subpage as NavigationCategory).elements.linkedPages.linkedItems,
                            //     );
                            //     (subpage as NavigationCategory).elements.linkToOverviewPage.value[0]
                            //       ? setExploreByOverviewPage(
                            //           (subpage as NavigationCategory).elements.linkToOverviewPage.value[0]
                            //             .codename,
                            //         )
                            //       : setExploreByOverviewPage('');
                            //     setIsChangingViewsExploreBy(false);
                            //   }, timeout);
                            // } else if (!(subpage as NavigationCategory).elements.linkedPages.linkedItems) {
                            //   setTimeout(() => {
                            //     setIsChangingViewsExploreBy(true);
                            //     setExploreByOverviewPage('');
                            //     setExploreByPages([]);
                            //     setIsChangingViewsExploreBy(false);
                            //   });
                            // }
                            setMegaMenuIndexMobile(2);
                          }}
                        >
                          {(subpage as NavigationCategory).elements.title.value}
                        </Box>
                      </Flex>
                    ) : (
                      <Flex
                        alignItems='center'
                        justifyContent={'space-between'}
                        gap='s'
                        sx={{
                          _after: {
                            content: '""',
                            borderBottom: '1px solid',
                            borderColor: 'cyan.web',
                            //
                            w: '100%',
                            display: {
                              base: 'none',
                              lg: 'none',
                            },
                          },
                        }}
                      >
                        <Box textStyle={{ base: 'desktop.body.book.s24', lg: 'desktop.body.book.s24' }}>
                          {/* TODO: (Ante) Look into overview pages locale change to change filters as well from url => should be done in variants */}
                          {subpage.system.type === 'navigation_language_item' ? (
                            <BaseLink
                              iconName='chevronRight'
                              positionLock={true}
                              type={LinkType.Menu}
                              href={'/[...slug].tsx'}
                              as={megaMenuActiveTab?.variants?.[url] || `/${url}`}
                              locale={url}
                              navLinkMode={true}
                              onClick={() => {
                                handleLanguageChange(url, cookie, setCookie);
                                //  removeInitialLocaleCookie('INITIAL_LOCALE');
                                setIsMegaMenuActive(false);
                              }}
                            >
                              {(subpage as NavigationLanguageItem).elements.title.value}
                            </BaseLink>
                          ) : (
                            <BaseLink
                              locale={router.locale}
                              positionLock={true}
                              href={url ?? '/'}
                              type={LinkType.Menu}
                              iconName='chevronRight'
                              navLinkMode={true}
                              onClick={() => setIsMegaMenuActive(false)}
                            >
                              {/* TODO: Add a link to website ver of selected language */}
                              {subpage.elements.summaryTitle.value}
                            </BaseLink>
                          )}
                        </Box>
                      </Flex>
                    )}
                  </ListItem>
                );
              })
            : null}
        </UnorderedList>
        {Array.isArray(navSections) && navSections.length > 0 && (
          <Box
            bg={'pebble.20'}
            borderRadius={'4px'}
            sx={{
              padding: { lg: '20px 10px 10px 10px', base: '24px 10px 24px 10px' },
              margin: { lg: 'unset', base: '10px 20px 10px 20px' },
              maxW: { base: 'unset', lg: '320px' },
            }}
          >
            <UnorderedList listStyleType={'none'} display={'flex'} gap={'30px'} flexFlow={'column'} margin={'0px'}>
              {navSections.map((navSecItm) => {
                const categoryType = navSecItm?.elements?.linkToOverviewPage?.value[0]?.codename + '';
                const sectionIcon = SECTION_ICON_MAPPING[categoryType];
                const sectionHref = `${
                  (router.locale ?? process.env.NEXT_PUBLIC_DEFAULT_LOCALE!) == 'en'
                    ? ''
                    : `/${router.locale ?? process.env.NEXT_PUBLIC_DEFAULT_LOCALE!}`
                }/${slugify(translations.multiple(categoryType), { lower: true })}`;
                //slugify(translations.multiple(linkToOverviewPage), { lower: true })
                return (
                  <ListItem
                    data-group='sectionlinkgrp'
                    as={'a'}
                    display={'flex'}
                    flexFlow={'column'}
                    padding={'10px'}
                    gap={'10px'}
                    href={sectionHref}
                    borderRadius={'4px'}
                    _hover={{ bg: '#fff', cursor: 'pointer' }}
                  >
                    <Box textStyle={'desktop.body.medium.xs'}>{navSecItm?.elements?.headline?.value}</Box>
                    <Flex direction={'row'} gap={'10px'} alignItems={'center'}>
                      <Box
                        w={'48px'}
                        h={'48px'}
                        borderRadius={'25px'}
                        bg={'#fff'}
                        flexShrink={0}
                        flex={'0 0 48px'}
                        sx={{
                          "[data-group='sectionlinkgrp']:hover &,[data-group='sectionlinkgrp']:focus-within &": {
                            bg: 'pebble.20',
                          },
                        }}
                        display={'flex'}
                        alignItems={'center'}
                        justifyContent={'center'}
                      >
                        {sectionIcon ? <IconComp iconName={sectionIcon} /> : <IconComp iconName='info' />}
                      </Box>
                      <Box textStyle={'desktop.body.book.xs'} color={'mountain.80'}>
                        {navSecItm?.elements?.description?.value}
                      </Box>
                    </Flex>
                  </ListItem>
                );
              })}
            </UnorderedList>
          </Box>
        )}
      </>
    );
  };

  // const url = router.locale == 'en' ? 'sv-se' : 'en';
  const mapNavLinks = (isSecondary: boolean) => {
    const primaryNavigation: any[] = [];
    const secondaryNavigation: any[] = [];
    NavLinks.forEach((item: any, index) => {
      if (item?.elements?.secondaryNavigationOption?.value[0]?.codename == 'yes') {
        secondaryNavigation.push(item);
      } else {
        primaryNavigation.push(item);
      }
    });

    return (isSecondary ? secondaryNavigation : primaryNavigation).map((link: any, index) => {
      const listItemHoverObj = {
        "[data-group='navbargroup']:hover &,[data-group='navbargroup']:focus-within &": {
          color:
            megaMenuActiveTab?.categoryTitle === link?.elements?.title?.value && isMegaMenuActive
              ? 'cyan.web'
              : 'mountain.base',
          svg: {
            path: {
              stroke:
                megaMenuActiveTab?.categoryTitle === link?.elements?.title?.value && isMegaMenuActive
                  ? 'cyan.web'
                  : 'mountain.base',
              fill:
                megaMenuActiveTab?.categoryTitle === link?.elements?.title?.value && isMegaMenuActive
                  ? 'cyan.web'
                  : 'mountain.base',
            },
          },
          _hover: {
            color: 'cyan.web',
            svg: { path: { stroke: 'cyan.web', fill: 'cyan.web' } },
          },
        },
      };
      const isLanguageSwitcher =
        link.system.type === 'navigation_item' &&
        (link as NavigationItem).elements.languageSwitcher.value[0]?.codename === 'yes';
      const navSections = link?.elements?.navigationSections?.linkedItems;

      const navigationOverviewLink = link.elements.linkToOverview?.value[0]?.codename;
      const navigationRootLink = link.elements.ctaInsteadOfHaLinkToKontentAiItems?.linkedItems[0];
      const shouldShowPopup = navigationOverviewLink || navigationRootLink ? false : true;
      const overViewLink = navigationOverviewLink
        ? `${
            (router.locale ?? process.env.NEXT_PUBLIC_DEFAULT_LOCALE!) == 'en'
              ? ''
              : `/${router.locale ?? process.env.NEXT_PUBLIC_DEFAULT_LOCALE!}`
          }/${
            navigationOverviewLink == 'contact'
              ? translations.multiple('contactUsUrl')
              : slugify(translations.multiple(navigationOverviewLink), { lower: true })
          }${navigationOverviewLink == 'contact' ? `/${translations.common('map')}` : ''}`
        : '/';
      const slug = router.query.slug || router.query.mainSubpage || router.query.subcategory;
      const url = navigationRootLink
        ? navigationRootLink.system.type === 'content_page'
          ? hrefLink(
              navigationRootLink,
              (slug as unknown as string)?.split('/'),
              true,
              translations.locale,
              translations,
            )
          : navigationRootLink.system.type === 'navigation_language_item'
          ? `${(navigationRootLink as NavigationLanguageItem).elements.languageCodename.value}`
          : navigationRootLink.system.type === 'content_page_actor'
          ? internalPages(
              translations,
              (navigationRootLink as ContentPageActor).elements.internalCtaLink.value[0]?.codename,
            ) ?? (navigationRootLink as ContentPageActor).elements.externalCtaLink.value
          : '/'
        : '/';
      const hrefRootLink = navigationRootLink ? url : navigationOverviewLink ? overViewLink : undefined;
      const hrefObj = shouldShowPopup ? {} : { href: hrefRootLink };

      return link.system.type === 'navigation_item' ? (
        <Popover
          placement={isSecondary ? 'bottom-end' : 'bottom-start'}
          modifiers={[
            { name: 'offset', options: isSecondary ? { offset: [0, 6] } : { offset: [-34, 6] } },
            { name: 'computeStyles', options: { gpuAcceleration: false } },
          ]}
          isOpen={shouldShowPopup && isMegaMenuActive && link.system.codename == megaMenuActiveTab?.codename}
          //onOpen={onOpen}
          //onClose={onClose}
        >
          {shouldShowPopup && (
            <PopoverContent w={'auto'} display={{ base: 'none', lg: 'flex' }}>
              <PopoverBody display={'flex'} flexFlow={'row'} p={0}>
                {flyoutMenu(link, navSections)}
              </PopoverBody>
            </PopoverContent>
          )}
          <PopoverTrigger>
            <ListItem
              key={link.elements.title.value}
              display='flex'
              height={{ base: 'auto', lg: 'inherit' }}
              alignItems='center'
              w={{ base: '100%', lg: 'auto' }}
              pb={{ base: '10px', lg: 0 }}
              pt={{ base: '10px', lg: 0 }}
              mx={isSecondary ? { lg: '10px' } : { lg: '15px' }}
              color={
                isOnFrontpage && !isMegaMenuActive && !isShowMainSearch
                  ? 'white'
                  : isSecondary
                  ? 'mountain.80'
                  : 'mountain.base'
              }
              _hover={{
                //borderBottom: { lg: '1px solid' },
                //borderColor: isOnFrontpage && !isMegaMenuActive && !isShowMainSearch ? 'white' : 'cyan.web',
                color: isOnFrontpage && !isMegaMenuActive && !isShowMainSearch ? 'white' : 'cyan.web',
                svg:
                  isOnFrontpage && !isMegaMenuActive && !isShowMainSearch
                    ? { path: { stroke: 'white' } }
                    : { path: { stroke: 'cyan.web', fill: 'none' } },
              }}
              sx={
                megaMenuActiveTab?.categoryTitle === link?.elements?.title?.value && isMegaMenuActive
                  ? {
                      ...listItemHoverObj,
                      '@media only screen and (min-width: 1024px)': {
                        color: 'cyan.web',
                        //borderBottom: '1px solid',
                        //borderColor: 'cyan.web',
                        svg: {
                          path: {
                            fill: 'none',
                            stroke: 'cyan.web',
                          },
                          transform: 'rotateZ(180deg)',
                        },
                      },
                      '@media only screen and (max-width: 1023px)': {
                        color: 'cyan.web',
                        //borderBottom: '1px solid',
                        //borderColor: 'cyan.web',
                        svg: {
                          path: {
                            fill: 'none',
                            stroke: 'cyan.web',
                          },
                          transform: 'rotateZ(-90deg)',
                        },
                      },
                    }
                  : isOnFrontpage && !isMegaMenuActive && !isShowMainSearch
                  ? {
                      ...listItemHoverObj,
                      svg: { path: { fill: 'none' } },
                      '@media only screen and (max-width: 1023px)': {
                        svg: {
                          transform: 'rotateZ(-90deg) scale(0.7)',
                        },
                      },
                    }
                  : {
                      ...listItemHoverObj,
                      '@media only screen and (max-width: 1023px)': {
                        svg: {
                          transform: 'rotateZ(-90deg) scale(0.7)',
                        },
                      },
                    }
              }
            >
              <Text
                suppressHydrationWarning
                {...hrefObj}
                as={shouldShowPopup ? 'button' : 'a'}
                textAlign='left'
                w={{ base: '100vw', lg: 'auto' }}
                textStyle={
                  isSecondary
                    ? { base: 'mobile.body.xs', lg: 'desktop.body.book.xxs' }
                    : isCampaign
                    ? { base: 'desktop.body.book.l', lg: 'desktop.body.book.s' }
                    : { base: 'desktop.body.book.l', lg: 'desktop.body.medium.s' }
                }
                // sx={{
                //   '@media only screen and (min-width: 1024px)': {
                //     svg: {
                //       transform: 'scale(0.7)',
                //     },
                //   },
                //   '@media only screen and (max-width: 1023px)': {
                //     svg: {
                //       transform: 'rotateZ(-90deg) scale(0.7)',
                //     },
                //   },
                // }}
                display='flex'
                alignItems='center'
                justifyContent={{ base: 'space-between', lg: 'unset' }}
                gap={{ base: 'xxs', lg: 0 }}
                aria-expanded={!isMegaMenuActive}
                aria-label={`${translations.aria('openMenuOnTab')}: ${link.elements.title.value}`}
                onClick={() => {
                  if (shouldShowPopup) {
                    const foundItem = megaMenuProps.find((item) => item.itemCodename === link.system.codename);
                    setMegaMenuIndexMobile(1);
                    setMegaMenuActiveTab({
                      link,
                      codename: link.system.codename,
                      isRST: navProps.system.codename,
                      linkToOverview: link.elements.linkToOverview.value[0]?.codename,
                      categoryDescription: link.elements.description.value,
                      categoryTitle: link.elements.title.value,
                      variants,
                      subpages: foundItem?.subpages,
                      highlightedArticle: foundItem?.highlightedArticle,
                      navSections: link?.elements?.navigationSections?.linkedItems,
                      ...(foundItem ? foundItem : {}),
                    });
                    // console.log('megamenutab', megaMenuActiveTab);
                    // console.log('clickedtab', link.elements.title.value);
                    // console.log('clickedcodename', link.system.codename);

                    // This should not happen on the mobile version
                    if (
                      megaMenuActiveTab?.categoryTitle === link?.elements?.title?.value &&
                      isMegaMenuActive &&
                      window.innerWidth >= 1024
                    ) {
                      setIsMegaMenuActive(false);
                    } else {
                      if (isShowMainSearch) {
                        setIsShowMainSearch(false);
                      }
                      setIsMegaMenuActive(true);
                    }
                  }
                }}
              >
                {isLanguageSwitcher ? (
                  <Box
                    suppressHydrationWarning
                    display='flex'
                    gap={{ base: 'xxs', lg: 0 }}
                    alignItems='center'
                    borderTop={'none'}
                    pt={0}
                    w={{ base: '100%' }}
                    mr={{ base: 'xxs', lg: '0' }}
                  >
                    {
                      languageSelectors.find(
                        (item) => item.elements.languageCodename.value === (router.locale ?? translations.locale),
                      )?.elements.title.value
                    }
                  </Box>
                ) : (
                  <>{link.elements.title.value}</>
                )}

                {link.elements?.subpages?.linkedItems?.length > 0 && (
                  <IconComp
                    iconName={chevIcon}
                    chakraStyle={{
                      //visibility: showPopup ? 'visible' : 'hidden',
                      display: shouldShowPopup ? 'block' : 'none',
                      svg: {
                        path: {
                          stroke: isOnFrontpage && !isMegaMenuActive && !isShowMainSearch ? 'white' : 'mountain.base',
                          fill: {
                            base: 'none',
                            lg: isOnFrontpage && !isMegaMenuActive && !isShowMainSearch ? 'white' : 'mountain.base',
                          },
                        },
                      },
                      marginLeft: { base: '5px' },
                    }}
                    //groupHover={{ path: { stroke: 'white' } }}
                  />
                )}
              </Text>
            </ListItem>
          </PopoverTrigger>
        </Popover>
      ) : // : link.system.type === 'navigation_item' && navProps.system.codename === 'rst_navigation' ? (
      //   <>
      //     <Select
      //       id='second'
      //       borderWidth='0px'
      //       textStyle='desktop.body.book.s'
      //       textColor='mountain'
      //       aria-label={translations.aria('languageSelector')}
      //       name={translations.aria('languageSelector')}
      //       w={'fit-content'}
      //       value={cookie.NEXT_LOCALE}
      //       onChange={() => {
      //         linkRef.current?.click();
      //       }}
      //     >
      //       {['Global', 'Sweden'].map((item) => {
      //         return (
      //           <option key={index} value={item == 'Global' ? 'en' : 'sv-se'}>
      //             {item}
      //           </option>
      //         );
      //       })}
      //     </Select>
      //   </>
      // )
      link.system.type === 'anchor_link_navigation_item' ? (
        <ListItem
          key={index}
          display='flex'
          height={'inherit'}
          alignItems='center'
          px={{ base: 0, lg: 'xs' }}
          py={{ base: '10px', lg: 0 }}
        >
          <Box
            as='a'
            color={
              isOnFrontpage && !isMegaMenuActive && !isShowMainSearch
                ? 'white'
                : isSecondary
                ? 'mountain.80'
                : 'mountain.base'
            }
            _hover={{
              color: 'cyan.web',
            }}
            textStyle={
              isSecondary
                ? { base: 'mobile.body.xs', lg: 'desktop.body.book.xxs' }
                : isCampaign
                ? { base: 'desktop.body.book.l', lg: 'desktop.body.book.s' }
                : { base: 'desktop.body.book.l', lg: 'desktop.body.medium.s' }
            }
            href={`#${link.elements.component.value[0]}`}
          >
            {link.elements.name.value}
          </Box>
        </ListItem>
      ) : link.system.type === 'content_page' ? (
        <ListItem
          key={index}
          display='flex'
          height={'inherit'}
          alignItems='center'
          px={{ base: 0, lg: 'xs' }}
          py={{ base: '10px', lg: 0 }}
          id='content_page'
        >
          <Box
            as='a'
            color={
              isOnFrontpage && !isMegaMenuActive && !isShowMainSearch
                ? 'white'
                : isSecondary
                ? 'mountain.80'
                : 'mountain.base'
            }
            _hover={{
              color: 'cyan.web',
            }}
            // textStyle={{ base: 'mobile.h3', lg: 'desktop.body.medium.s' }}
            textStyle={
              isSecondary
                ? { base: 'mobile.body.xs', lg: 'desktop.body.book.xxs' }
                : isCampaign
                ? { base: 'desktop.body.book.l', lg: 'desktop.body.book.s' }
                : { base: 'desktop.body.book.l', lg: 'desktop.body.medium.s' }
            }
            href={
              Object.keys(
                normalize(
                  link,
                  cookie.NEXT_LOCALE ?? process.env.NEXT_PUBLIC_DEFAULT_LOCALE!,
                  undefined,
                  true,
                  translations,
                ),
              )[0] ?? ''
            }
          >
            {link.elements.summaryTitle.value}
          </Box>
        </ListItem>
      ) : link.system.type === 'content_page_actor' ? (
        <ListItem
          key={index}
          display='flex'
          height={'inherit'}
          alignItems='center'
          px={{ base: 0, lg: 'xs' }}
          py={{ base: '10px', lg: 0 }}
          id='content_page_actor'
        >
          <Box
            as='a'
            color={
              isOnFrontpage && !isMegaMenuActive && !isShowMainSearch
                ? 'white'
                : isSecondary
                ? 'mountain.80'
                : 'mountain.base'
            }
            _hover={{
              color: 'cyan.web',
            }}
            // textStyle={{ base: 'mobile.h3', lg: 'desktop.body.medium.s' }}
            textStyle={
              isSecondary
                ? { base: 'mobile.body.xs', lg: 'desktop.body.book.xxs' }
                : isCampaign
                ? { base: 'desktop.body.book.l', lg: 'desktop.body.book.s' }
                : { base: 'desktop.body.book.l', lg: 'desktop.body.medium.s' }
            }
            href={getContentActorHrefLink(link, translations)}
          >
            {link.elements.ctaText?.value}
          </Box>
        </ListItem>
      ) : null;
    });
  };

  const getContentActorHrefLink = (link, translations) => {
    return link.elements.internalCtaLink.value[0]?.codename
      ? `${translations.locale}${internalPages(translations, link.elements.internalCtaLink.value[0]?.codename)}`
      : link.elements.externalCtaLink.value;
  };

  const CampaignNavBarItems = () => {
    return (
      <Flex
        // w='100%'
        // flexDirection={{ base: 'column', lg: 'row' }}
        // justifyContent={{ base: '', lg: 'space-between' }}
        // ml={{ base: '0', lg: 'm' }}
        // h='100%'
        // overflowY={{ base: 'scroll', lg: 'unset' }}
        listStyleType={'none'}
        display='flex'
        flexDirection={{ base: 'column', lg: 'row' }}
        justifyContent={{ lg: 'space-evenly' }}
        margin='0'
        pt={0}
        w={{ base: '100%', lg: 'auto' }}
        sx={{
          '@media screen and (max-width: 1023px)': {
            gap: '10px',
            pt: '40px',
            pb: '30px',
          },
        }}
      >
        <UnorderedList
          listStyleType={'none'}
          position='relative'
          height={{ base: 'unset', lg: '100%' }}
          display='flex'
          flexDirection={{ base: 'column', lg: 'row' }}
          alignItems={{ base: 'start', lg: 'center' }}
          pt={{ base: 'xs', lg: '0' }}
          mb={{ base: '0', lg: 'unset' }}
          marginInlineStart={0}
          sx={{
            '@media screen and (max-width: 1024px)': {
              gap: '10px',
              pt: '0',
              m: 'unset',
            },
          }}
        >
          {mapNavLinks(false)}
          <ListItem mx={{ lg: '30px' }} display={{ base: 'none', lg: 'flex' }}>
            <Box as={'button'} onClick={toggleMainSearch}>
              <IconComp iconName='searchSmall' />
            </Box>
          </ListItem>
        </UnorderedList>
        {/* <Flex flexDir={{ base: 'column', lg: 'row' }} gap='30px' alignItems={{ base: 'start', lg: 'center' }}>
        
        </Flex> */}
        <Flex flexDir={{ base: 'column', lg: 'row' }} gap='30px' alignItems={{ base: 'start', lg: 'center' }}>
          {shouldShowLanguageSelector && (
            //  navProps.system.codename !== 'rst_navigation' &&
            <Select
              id='second'
              borderWidth='0px'
              textStyle='desktop.body.book.s'
              textColor='mountain'
              aria-label={translations.aria('languageSelector')}
              name={translations.aria('languageSelector')}
              w={'fit-content'}
              value={cookie.NEXT_LOCALE}
              onChange={(e) => handleLanguageChange(e.target.value, cookie, setCookie)}
            >
              {languageSelectors.map((language, index) => {
                return (
                  <option key={index} value={language.elements.languageCodename.value}>
                    {language.elements.languageName.value}
                  </option>
                );
              })}
            </Select>
          )}
        </Flex>
      </Flex>
    );
  };

  const secNavItems = mapNavLinks(true);
  return (
    <>
      {(isMegaMenuActive || isShowMainSearch) && (
        <div
          style={{
            position: 'absolute',
            zIndex: 9,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.07)',
          }}
        ></div>
      )}
      <Box
        key={router.asPath}
        pt={{ base: isRemovePadding ? '0' : '70px', lg: isRemovePadding ? '0' : '100px' }}
        position={'relative'}
        id='RambollNavBar'
        zIndex={10}
        // boxShadow = {isMegaMenuActive ? '4px 4px 4px 0px #d4d7d9 inset' : 'none'}
      >
        {/* ---------------- NAV BAR ---------------- */}
        <Box
          background={
            isOnFrontpage && !isMegaMenuActive && !isShowMainSearch
              ? 'linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 100%)'
              : 'white'
          }
          transition='transform 0.3s ease, background 0.75s'
          transform={`translate(-50%, ${!isShowNav ? '-100%' : '0%'})`}
          position={'fixed'}
          top='0'
          left='50%'
          w='100%'
          maxW={{ base: '1440px', lg: moduleMaxWidth }}
          zIndex={10}
        >
          {languageSelectors.length > 1 && <LocationPopup languages={languageSelectors} variants={variants} />}
          <Box
            position={'relative'}
            data-group='navbargroup'
            background={
              isCampaign ? 'white' : isOnFrontpage && !isMegaMenuActive && !isShowMainSearch ? 'transparent' : 'white'
            }
            transition={isRemovePadding ? 'background 0.75s' : undefined}
            zIndex={10}
            _hover={{ base: { background: 'transparent' }, lg: { background: 'white' } }}
            // style={{ pointerEvents: router.locale != cookie['NEXT_LOCALE'] ? 'none' : 'auto' }}
          >
            <NavBarMobile />
            <NavBarDesktop />
          </Box>
          {/* ---------------- NAV BAR END ---------------- */}

          {/* ---------------- BACKGROUND SHADOW (OPEN MEGA MENU) ---------------- */}
          {/* <Box
            w='100%'
            h='100vh'
            position='absolute'
            background='mountain.base'
            transition='opacity 0.75s'
            opacity={isMegaMenuActive ? '0.3' : 0}
            pointerEvents='none'
            // boxShadow='4px 4px 4px 0px mountain.20 inset'
          ></Box> */}
          {/* ---------------- BACKGROUND SHADOW (OPEN MEGA MENU) END ---------------- */}

          {/* ---------------- MEGA MENU ---------------- */}
          <Flex
            bg={'white'}
            opacity={{ lg: isOnFrontpage && !isMegaMenuActive && !isShowMainSearch ? 0 : !isMegaMenuActive ? 0 : 1 }}
            position='absolute'
            zIndex={8}
            pb={{ base: '68px', lg: '0px' }}
            mb={{ base: '15px', lg: '0px' }}
            w={{ base: '100vw', lg: 'auto' }}
            h={{ base: 'calc(100dvh + 5px)', lg: 'auto' }}
            sx={{
              '@media screen and (width: 1024px)': {
                h: 'calc(100vh - 75px)',
                overflow: 'auto',
              },
              '@media screen and (max-height: 900px) and (min-width: 1024px)': {
                h: 'calc(100vh - 75px)',
                overflow: 'auto',
              },
            }}
            // overflow={'auto'}
            transition={
              isOnFrontpage
                ? 'transform 0.75s, opacity 0.75s'
                : !isMegaMenuActive
                ? 'transform 0.75s, opacity 0s 0.75s'
                : 'transform 0.75s'
            }
            transform={{
              base: !isMegaMenuActive
                ? `translateY(-200%) translateX(-${100 * megaMenuIndexMobile}vw)`
                : `translateY(-1px) translateX(-${100 * megaMenuIndexMobile}vw)`,
              lg: !isMegaMenuActive ? 'translateY(-100%)' : 'translateY(0)',
            }}
          >
            <Box
              w={{ base: '100%', lg: '100%' }}
              flex='0 0 100%'
              display={{ base: 'inline-flex', lg: 'none' }}
              justifyContent={{ base: 'flex-start', lg: 'space-between' }}
              flexFlow={{ base: 'column nowrap', lg: 'row wrap' }}
              px='xs'
              overflowY={{ base: 'auto', lg: 'unset' }}
              pb={{ base: '108px', lg: 'unset' }}
            >
              {isCampaign ? <CampaignNavBarItems /> : <NavBarItems />}
              {Array.isArray(secNavItems) && secNavItems.length > 0 && (
                <Box display={{ base: 'block', lg: 'none' }} height={'1px'} borderTop={'1px solid #D4D7D9'}></Box>
              )}
              <Box w={{ base: 'calc(100vw - 40px)', lg: 'auto' }}>
                <UnorderedList
                  listStyleType={'none'}
                  display='flex'
                  height={'100%'}
                  position='relative'
                  flexDirection={{ base: 'column', lg: 'row' }}
                  alignItems={{ base: 'start', lg: 'center' }}
                  pt={{ base: '30px', lg: '0' }}
                  mb={{ base: '0', lg: 'unset' }}
                  marginInlineStart={0}
                  sx={{
                    '@media screen and (max-width: 1024px)': {
                      pt: '30px',
                      m: 'unset',
                    },
                  }}
                >
                  {secNavItems}
                </UnorderedList>
              </Box>
            </Box>

            <Container
              display={isOnFrontpage && !isMegaMenuActive ? 'none' : 'unset'}
              w={{ base: 'unset' }}
              bg='#fff'
              maxW={moduleMaxWidth}
              paddingInlineStart={{ base: '0', md: '0', lg: '0' }}
              paddingInlineEnd={{ base: '0', md: '0', lg: '0' }}
              marginInlineStart='0'
              marginInlineEnd='0'
              height='100%'
              sx={{ display: { base: 'flex', lg: 'none' } }}
            >
              <Box
                width={'unset'}
                maxWidth={1920}
                height={'100%'}
                display={'flex'}
                opacity={1}
                transition={'opacity 0.3s'}
              >
                <Box
                  w={'100vw'}
                  display={'flex'}
                  flexFlow={'column nowrap'}
                  overflow={{ base: 'auto', lg: 'visible' }}
                  pt={megaMenuIndexMobile > 0 ? { base: '40px', lg: '0px' } : { base: '40px', lg: 'unset' }}
                  pb={megaMenuIndexMobile > 0 ? { base: '68px', lg: '0px' } : {}}
                >
                  <Box display={{ base: 'block', lg: 'none' }}>
                    <Box margin={'0px 20px'}>
                      <Breadcrumb
                        name={megaMenuActiveTab?.categoryTitle}
                        style={{ pt: '2px', pb: '2px' }}
                        onClick={() => {
                          setMegaMenuIndexMobile(0);
                        }}
                      />
                    </Box>
                    <Box
                      display={{ base: 'block', lg: 'none' }}
                      height={'10px'}
                      margin={'0px 20px'}
                      borderBottom={'1px solid #D4D7D9'}
                    ></Box>
                  </Box>
                  {flyoutMenu(megaMenuActiveTab?.link, megaMenuActiveTab?.navSections)}
                </Box>
              </Box>
            </Container>
          </Flex>
          {/* ---------------- MEGA MENU ---------------- */}

          {/* ---------------- SEARCH ---------------- */}
          {/* {!isCampaign && ( */}
          <Flex
            bg={isOnFrontpage && !isMegaMenuActive && !isShowMainSearch ? 'transparent' : 'white'}
            transition={'background 0.75s, transform 0.75s, opacity 0.75s'}
            position='absolute'
            transform={!isShowMainSearch ? 'translateY(-100%)' : 'translateY(0)'}
            w='100%'
            opacity={isOnFrontpage && !isShowMainSearch ? '0' : '1'}
          >
            {/* {!isCampaign && ( */}
            <Flex
              bg={isOnFrontpage && !isMegaMenuActive && !isShowMainSearch ? 'transparent' : 'white'}
              transition={
                isOnFrontpage
                  ? 'background 0.75s, transform 0.75s, opacity 0.75s'
                  : !isShowMainSearch
                  ? 'transform 0.75s, opacity 0s 0.75s'
                  : 'transform 0.75s'
              }
              position='absolute'
              transform={!isShowMainSearch ? 'translateY(-100%)' : 'translateY(0)'}
              w='100%'
              opacity={(isOnFrontpage && !isShowMainSearch) || !isShowMainSearch ? '0' : '1'}
            >
              <MainSearch placeholder={mainSearch?.elements.placeholder.value} toggleSearch={toggleMainSearch} />
            </Flex>
            {/* )} */}
          </Flex>
          {/* )} */}
          {/* ---------------- SEARCH END ---------------- */}
        </Box>
      </Box>
    </>
  );
};
